import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function FAQ() {
  const faqs = [{
    q: '¿Funciona si ya entreno fuerte?',
    a: 'Especialmente si ya entrenás fuerte. Cuanto más peso manejás, más crítico se vuelve el agarre. Este sistema te permitirá transferir toda esa fuerza que ya tenés sin que tus manos sean el límite.'
  }, {
    q: '¿Cuánto tiempo lleva?',
    a: 'El sistema está diseñado para integrarse a tu rutina actual. Solo necesitas sumar 10-15 minutos específicos al final de tus sesiones, 2 o 3 veces por semana.'
  }, {
    q: '¿Necesito equipamiento especial?',
    a: 'No para empezar. El sistema incluye progresiones usando el equipamiento estándar de cualquier gimnasio (barras, discos, mancuernas). La guía de accesorios te indicará qué comprar solo si querés llevarlo al siguiente nivel.'
  }, {
    q: '¿Es para principiantes o avanzados?',
    a: 'El sistema se adapta a tu nivel actual. Los principios biomecánicos (Crush, Pinch, Support) son los mismos, lo que cambia es la carga y la progresión que aplicarás según tu punto de partida.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-dark-800 border-t border-dark-700" data-id="element-41">
      <div className="container mx-auto px-4" data-id="element-42">
        <SectionHeading title="PREGUNTAS FRECUENTES" data-id="element-43" />

        <div className="max-w-3xl mx-auto mt-12 space-y-4" data-id="element-44">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-900 border border-dark-700 rounded-xl overflow-hidden" data-id="element-45">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-46">
                <span className="font-oswald font-bold text-xl text-white" data-id="element-47">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-neon-cyan transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-48" />
              </button>

              <AnimatePresence data-id="element-49">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-50">
                    <div className="px-6 pb-5 text-gray-400 font-inter border-t border-dark-800 pt-4" data-id="element-51">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}